// extracted by mini-css-extract-plugin
module.exports = {"ctn":"PlansCard_ctn__We15L","button":"PlansCard_button__9Ae_t","text":"PlansCard_text__1-V0K"};